/* unplugin-vue-components disabled */import { render } from "./RepairMessage.vue?vue&type=template&id=10a9d58b&scoped=true"
import script from "./RepairMessage.vue?vue&type=script&lang=js"
export * from "./RepairMessage.vue?vue&type=script&lang=js"

import "./RepairMessage.vue?vue&type=style&index=0&id=10a9d58b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a9d58b"]])

export default __exports__